import * as t from 'io-ts';

import {AnalyticsReportsEnum} from '../../../../analytics/helpers/analyticsReportHelpers';
import {makeEnumRuntimeType} from '../../../../models/api/apiTypes';

export enum AnalyticsParametersNamespacesEnum {
  TEAM_REPORT = 'TEAM_REPORT',
  TEAMMATE_REPORT = 'TEAMMATE_REPORT',
  GLOBAL = 'GLOBAL',
}

export const RAnalyticsParametersNamespace = makeEnumRuntimeType(AnalyticsParametersNamespacesEnum);

export const RAnalyticsLocation = t.type({
  pathname: t.string,
  search: t.string,
});

export const RAnalyticsQueryParams = t.type({
  from: t.number,
  to: t.number,
  selectedViewId: t.union([t.string, t.number, t.undefined]),
});

export const RAnalyticsParametersBase = t.type({
  namespace: RAnalyticsParametersNamespace,
  location: RAnalyticsLocation,
  reportType: makeEnumRuntimeType(AnalyticsReportsEnum),
  query: RAnalyticsQueryParams,
});

const RAnalyticsTeamReportParameters = t.intersection([
  RAnalyticsParametersBase,
  t.type({
    namespace: t.literal(AnalyticsParametersNamespacesEnum.TEAM_REPORT),
  }),
  t.type({
    teamId: t.string,
  }),
]);

const RAnalyticsTeammateReportParameters = t.intersection([
  RAnalyticsParametersBase,
  t.type({
    namespace: t.literal(AnalyticsParametersNamespacesEnum.TEAMMATE_REPORT),
  }),
  t.type({
    teammateId: t.string,
  }),
]);

const RAnalyticsGlobalReportParameters = t.intersection([
  RAnalyticsParametersBase,
  t.type({
    namespace: t.literal(AnalyticsParametersNamespacesEnum.GLOBAL),
  }),
]);

/*
 * Union of parameters.
 */

const RAnalyticsParametersDirty = t.taggedUnion('type', [
  RAnalyticsTeamReportParameters,
  RAnalyticsTeammateReportParameters,
  RAnalyticsGlobalReportParameters,
]);

export const RAnalyticsParameters = t.clean<AnalyticsParameters>(RAnalyticsParametersDirty as any);

export interface AnalyticsTeamReportParameters
  extends Readonly<t.TypeOf<typeof RAnalyticsTeamReportParameters>> {}

export interface AnalyticsTeammateReportParameters
  extends Readonly<t.TypeOf<typeof RAnalyticsTeammateReportParameters>> {}

export interface AnalyticsGlobalReportParameters
  extends Readonly<t.TypeOf<typeof RAnalyticsGlobalReportParameters>> {}

export interface AnalyticsLocation extends t.TypeOf<typeof RAnalyticsLocation> {}

export type AnalyticsParameters =
  | AnalyticsTeamReportParameters
  | AnalyticsTeammateReportParameters
  | AnalyticsGlobalReportParameters;
